<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W737F/tc-custom/9781460303719.jpg?1699747137673" alt="This image is the cover for the book Billionaire's Baby Sos, The Larkville Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billionaire's Baby Sos, The Larkville Legacy
      </h1>
      <p class="bookDescription body article font2">
        <p>Successful CEO Matt Patterson isn't called the Ice Man for nothinghe's built up his multibillion-dollar company through cool decision-making and a ruthless reputation. But now he has a new challenge to face<i>fatherhood!</i><br/><br/>Finding himself guardian to gorgeous baby Bella, Matt's more comfortable in the boardroom than changing a diaper. Lucky, then, that social worker Claire Kincaid agrees to play temporary mom. Happy families might never have been in Matt's plans, but Claire and little Bella are opening his eyes to a life that money could never buy<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Meier
      </h2>
      
      <p class="authorDescription body article">Susan Meier spent most of her twenties thinking she was a job-hopper &ndash; until she began to write and realised everything that had come before was only research! One of eleven children, with twenty-four nieces and nephews and three kids of her own, Susan lives in Western Pennsylvania with her wonderful husband, Mike, her children, and two over-fed, well-cuddled cats, Sophie and Fluffy. You can visit Susan&rsquo;s website at www.susanmeier.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0107ca58